import {
  DEFAULT_NA,
  PROFILE_SUBNAME,
  RESULT_STATE,
} from '../newrelic-constants';

import {
  getEnvironmentMicro,
} from '../newrelic-helpers';

export function nrLogin(globalState, actionName, fullStory, metricData) {
  const data = {
    actionSubname: PROFILE_SUBNAME.WEBLOGIN,
    entryPoint: metricData && metricData.action && metricData.action.entryPoint || DEFAULT_NA,
    environment: getEnvironmentMicro(),
    errorCode: metricData.resultState === RESULT_STATE.FAILURE ? metricData.action.result.errorCode : DEFAULT_NA,
    ffn: metricData.action.ffn || DEFAULT_NA,
    flow: 'MYB',
    fullstory: fullStory || DEFAULT_NA,
    request: DEFAULT_NA,
    resultState: metricData.resultState || DEFAULT_NA,
    risk: DEFAULT_NA,
    step: 'sign out', // sessionID | sign in | validate session | sign out
    storefront: metricData?.storefront,
    subflow: 'ancillary',
    url: window.location.href || DEFAULT_NA,
  };
  window.newrelic.addPageAction(actionName, data);
}